"use client";
import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import useSiniestrosStore from '../../../store/siniestrosStore';
import { getToken } from '../../../utils/claimManager';
import { Loader } from '../../../components';
import { Button, Select } from 'atm-global-stylish/dist';
import { useNavigate } from 'react-router-dom';
import { FormVehicular, FormThings } from '../../../components'
import FormInjures from '../../../components/FormInjures/FormInjures';
import { InjuredCard } from '../../../components/FormInjures';
import { isEmpty, scrollToTop, showModal } from '../../../utils/functions';
import { SELECT_CLASSNAME } from '../../../config/constants';

const Step4 = ({ config, lastAvanzar, retroceder, instance, handleUpdateClaim, validateClaim, submitClaim, getInstance, clearInstance }) => {
    const { loading, deleteInjured, createInjured, uploadFiles, } = useSiniestrosStore();
    const navigation = useNavigate();
    const [subStep, setSubStep] = useState(null);
    const [lesionados, setLesionados] = useState('0');
    const [options_insured, setOptionsInsured] = useState([{ value: '0', title: "¿Hay lesionados? *" }]);

    const [uploadingLesionado, setUploadingLesionado] = useState(true);
    const [localLoading, setLocalLoading] = useState(false);
    const [thisToken, setToken] = useState('');
    const [lesionado, setLesionado] = useState({
        name: '',
        dni: '',
        phone: '',
        phone_area: '',
        phone_number: '',
        mail: '',
        address: '',
        detail: '',
        bonding: '',
        sex: '',
        level: '',
        //  transported: '',
        photo_dni_front: '',
        photo_dni_back: '',
        photo_medical_certification: '',
        photo_police_report: '',
        photo_additional_6: '',
    });

    const [photos, setPhotos] = useState({
        photo_dni_front: null,
        photo_dni_back: null,
        photo_green_front: null,
        photo_green_back: null,
        photo_driver_license_front: null,
        photo_driver_license_back: null,
        photo_coverage_certification: null,
        photo_sinister_complaint: null,
        photo_invoice_for_repairments: null,
        photo_additional_1: null,
        photo_additional_2: null,
        photo_additional_3: null,
        photo_additional_4: null,
        photo_additional_5: null,
        photo_additional_6: null,
        photo_medical_certification: null,
        photo_police_report: null,
    });

    const [errors, setErrors] = useState({});
    const [options_bonding, setOptionsBonding] = useState([]);
    const [options_gender, setOptionsGender] = useState([]);
    const [options_injuries, setOptionsInjuries] = useState([]);


    useEffect(() => {
        setOptionsInsured([
            { value: '0', title: "¿Hay lesionados? *" },
            { value: '1', title: "SI HAY LESIONADOS" },
            { value: '2', title: "NO HAY LESIONADOS" },
        ]);
    }, []);

    useEffect(() => {
        const token = getToken();
        setToken(token);
        if (!token) {
            clearInstance();
            navigation('/');
        } else {
            getInstance(token).then(() => {
                const count = instance?.injures?.length ?? 0;
                if (count > 0) setLesionados(1);
                setUploadingLesionado(count !== 1);
            })
        }
    }, []);

    useEffect(() => {
        if (config.gender_list) {
            setOptionsGender([
                { value: "", title: "Género * " },
                ...Object.entries(config?.gender_list || {}).map(([key, value]) => ({
                    value: key,
                    title: value
                }))
            ]);
        }
        if (config.bonding_type) {
            setOptionsBonding([
                { value: "", title: "Tipo de relación con el asegurado *" },
                ...Object.entries(config?.bonding_type || {}).map(([key, value]) => ({
                    value: key,
                    title: value
                }))
            ]);
        }
        if (config.injured_level) {
            setOptionsInjuries([
                { value: "", title: "Gravedad de la lesión *" },
                ...Object.entries(config?.injured_level || {}).map(([key, value]) => ({
                    value: key,
                    title: value
                }))
            ]);
        }
    }, [config]);

    useEffect(() => {
        if (!instance) return;
        setSubStep(instance?.step === '4.2' ? 2 : 1);
    }, [instance]);

    const validateEmail = (value) => {
        const regex = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;

        return regex.test(value);
    }

    const injuresCount = instance?.injures?.length > 0 ?? 0;

    const shouldShowInjuresSection = (lesionados === 1 || instance?.things === '0')

    const showInjuresForm =
        shouldShowInjuresSection &&
        (
            injuresCount === 0 ||
            injuresCount > 1 ||
            uploadingLesionado === true ||
            instance?.things === '0'
        );

    const showAddAnotherButton =
        shouldShowInjuresSection &&
        injuresCount === 1 &&
        uploadingLesionado === false &&
        instance?.things !== '0';

    const disabled = useMemo(() => {
        return !(
            lesionado.name !== '' &&
            lesionado.dni !== '' &&
            lesionado.phone !== '' &&
            lesionado.mail !== '' &&
            lesionado.address !== '' &&
            lesionado.detail !== '' &&
            lesionado.photo_dni_front !== '' &&
            lesionado.photo_dni_back !== '' &&
            lesionado.photo_medical_certification !== '' &&
            lesionado.photo_police_report !== '' &&
            lesionado.name.length >= 3 &&
            lesionado.dni.length >= 8 &&
            lesionado.address.length >= 3 &&
            lesionado.detail.length >= 3 &&
            lesionado.mail.length >= 10 &&
            lesionado.bonding !== '' &&
            lesionado.sex !== '' &&
            lesionado.level !== '' &&
            lesionado.photo_additional_6 !== '' &&
            validateEmail(lesionado.mail)
        );
    }, [lesionado.name, lesionado.dni, lesionado.phone, lesionado.mail, lesionado.address, lesionado.detail, lesionado.photo_dni_front, lesionado.photo_dni_back, lesionado.photo_medical_certification, lesionado.photo_police_report, lesionado.bonding, lesionado.sex, lesionado.level, lesionado.photo_additional_6]);

    const handleInjured = async () => {
        if (disabled) {
            await showModal('¡UPS! Datos incorrectos', 'Revisá que los datos ingresados sean correctos.', 'warning');
            return
        }
        if (!disabled) {
            const data = {
                name: lesionado.name,
                dni: lesionado.dni,
                phone: lesionado.phone,
                mail: lesionado.mail,
                address: lesionado.address,
                detail: lesionado.detail,
                bonding: lesionado.bonding,
                sex: lesionado.sex,
                level: lesionado.level,
                // transported: lesionado.transported,
                photo_dni_front: lesionado.photo_dni_front,
                photo_dni_back: lesionado.photo_dni_back,
                photo_medical_certification: lesionado.photo_medical_certification,
                photo_police_report: lesionado.photo_police_report,
                photo_additional_6: lesionado.photo_additional_6,
            }
            setLocalLoading(true);

            try {
                const cleanData = Object.fromEntries(
                    Object.entries(data).filter(([_, v]) => v !== '' && v !== null && v !== undefined)
                );

                const beforeCount = instance?.injures?.length ?? 0;
                const updated = await createInjured(thisToken, cleanData);

                if (updated) {
                    setLesionado({
                        name: '',
                        dni: '',
                        phone: '',
                        mail: '',
                        address: '',
                        detail: '',
                        bonding: '',
                        sex: 2,
                        level: 2,
                        //   transported: '',
                        photo_dni_front: '',
                        photo_dni_back: '',
                        photo_medical_certification: '',
                        photo_police_report: '',
                        photo_additional_6: '',
                    })

                    await getInstance(thisToken);
                    setUploadingLesionado(beforeCount >= 1)

                } else {
                    await showModal('¡UPS! Datos incorrectos', 'Revisá que los datos ingresados sean correctos.', 'warning');
                }
            } catch (error) {
                await showModal('¡UPS! Hubo un error', error.message, 'error');
            } finally {
                setLocalLoading(false);
            }

        }
    };

    const handleDeleteInjured = async (id) => {
        setLocalLoading(true);
        try {
            const updated = await deleteInjured(thisToken, id);
            if (updated) {
                await getInstance(thisToken);
                setLocalLoading(false)
            }
        } catch (error) {
            await showModal('¡UPS! Hubo un error', '', 'error');
        } finally {
            setLocalLoading(false);
        }

    };

    const validateFields = () => {
        const newErrors = {};
        //const optional = instance?.injures?.length > 0 ? true : false;

        switch (instance?.things) {
            //VEHICULAR
            case '2':
            case '3':
                if (!photos.photo_dni_front) newErrors.photo_dni_front = true;
                if (!photos.photo_dni_back) newErrors.photo_dni_back = true;
                if (!photos.photo_green_front) newErrors.photo_green_front = true;
                if (!photos.photo_green_back) newErrors.photo_green_back = true;
                if (!photos.photo_driver_license_front) newErrors.photo_driver_license_front = true;
                if (!photos.photo_driver_license_back) newErrors.photo_driver_license_back = true;
                if (!photos.photo_coverage_certification) newErrors.photo_coverage_certification = true;
                if (!photos.photo_sinister_complaint) newErrors.photo_sinister_complaint = true;
                if (!photos.photo_invoice_for_repairments) newErrors.photo_invoice_for_repairments = true;
                if (!photos.photo_additional_1) newErrors.photo_additional_1 = true;
                if (!photos.photo_additional_2) newErrors.photo_additional_2 = true;
                if (!photos.photo_additional_3) newErrors.photo_additional_3 = true;
                if (!photos.photo_additional_4) newErrors.photo_additional_4 = true;
                if (!photos.photo_additional_5) newErrors.photo_additional_5 = true;
                // if (optional && !photos.photo_medical_certification) newErrors.photo_medical_certification = true;
                // if (optional && !photos.photo_police_report) newErrors.photo_police_report = true;
                break;
            // BICICLETA
            case '1':
                if (!photos.photo_dni_front) newErrors.photo_dni_front = true;
                if (!photos.photo_dni_back) newErrors.photo_dni_back = true;
                if (!photos.photo_invoice_for_repairments) newErrors.photo_invoice_for_repairments = true;
                // if (optional && !photos.photo_medical_certification) newErrors.photo_medical_certification = true;
                // if (optional && !photos.photo_police_report) newErrors.photo_police_report = true;
                // if (optional && !photos.photo_additional_6) newErrors.photo_additional_6 = true;
                break;
            //CAMINANDO
            case '0':
                if (!photos.photo_dni_front) newErrors.photo_dni_front = true;
                if (!photos.photo_dni_back) newErrors.photo_dni_back = true;
                // if (optional && !photos.photo_medical_certification) newErrors.photo_medical_certification = true;
                // if (optional && !photos.photo_police_report) newErrors.photo_police_report = true;
                break;
            //CASA
            case '4':
                if (!photos.photo_dni_front) newErrors.photo_dni_front = true;
                if (!photos.photo_dni_back) newErrors.photo_dni_back = true;
                if (!photos.photo_additional_6) newErrors.photo_additional_6 = true;
                if (!photos.photo_invoice_for_repairments) newErrors.photo_invoice_for_repairments = true;
                // if (optional && !photos.photo_medical_certification) newErrors.photo_medical_certification = true;
                // if (optional && !photos.photo_police_report) newErrors.photo_police_report = true;
                break;
            default:

                break;
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const submitFiles = async () => {
        const isValid = validateFields();
        if (!isValid) {
            await showModal('Campos incompletos', 'Por favor, revisá que todos los campos obligatorios estén completos y correctos.', 'warning');
            return false;
        }

        const cleanedData = Object.fromEntries(
            Object.entries(photos).filter(([_, v]) => v !== null && v !== undefined && v !== '')
        );


        try {
            const updated = await uploadFiles(thisToken, cleanedData);

            if (!updated) {
                return;
            }

            return true;
        } catch (error) {
            await showModal('¡UPS! Hubo un error inesperado', error.message || "Error desconocido al actualizar el reclamo", 'error');
        }
    };

    const handleChange = (field) => (eOrVal) => {
        const value = eOrVal?.target ? eOrVal.target.value : eOrVal;
        setLesionado(prev => ({ ...prev, [field]: value }));
    };

    const nextStep = async () => {
        try {
            const isUpdated = await submitFiles();

            if (!isUpdated) {
                return;
            }

            await handleUpdateClaim(getToken(), { 'step': '4.2' });
            await getInstance(getToken());
            setSubStep(2);
        } catch (err) {
            await showModal('¡UPS! Hubo un error inesperado', err.message || "Error desconocido al actualizar el reclamo", 'error');
        }
    }

    const handleSendClaim = async () => {
        const injuresValid = instance.injures.length > 0;
        if (
            (lesionados === 1 && !injuresValid) ||
            (instance?.things === '0' && !injuresValid)
        ) {
            await showModal('Error', "Debe completar los lesionados", 'error');
            return;
        }

        try {
            const req = await validateClaim(thisToken);

            if (req?.status === 200 || req?.status === 201) {

                const submitResponse = await submitClaim(thisToken);

                if (submitResponse?.response?.status !== 400) {
                    scrollToTop();
                    lastAvanzar();
                } else {
                    await showModal('¡UPS! Hubo un error inesperado', 'No se pudo presentar la denuncia, intente más tarde.', 'error');
                }
            } else if (req?.response?.status === 400) {
                await showModal('¡UPS! Hubo un error inesperado', typeof req.response.data === 'string' ? req.response.data : req.response.data[0], 'error');
            } else {
                await showModal('¡UPS! Hubo un error inesperado', 'Error inesperado validando el reclamo', 'warning');
            }
        } catch (err) {
            await showModal('¡UPS! Hubo un error inesperado', err.message || "Error desconocido al actualizar el reclamo", 'error');
        }
    }
    
    const backSubStep = async () => {
        await handleUpdateClaim(getToken(), { 'step': '4' });
        await getInstance(getToken());
        setSubStep(1);
    }

    const backStep = async () => {
        const tipo = instance?.things;
        const isOwner = instance?.claimant_person_is_vehicle_owner;

        if ((tipo === '3' || tipo === '2') && isOwner === '1') {
            await retroceder(3.2);
        } else if (tipo !== '0' && isOwner === '0') {
            await retroceder(3.2)
        } else {
            await retroceder(3);
        }
    }

    if (loading || localLoading || !subStep) return <Loader />
    return (
        <div className='step1 md:w-8/12 m-auto my-8 px-5 md:px-0'>
            {(subStep === 1) &&
                <div className='flex w-full m-auto flex-col gap-3'>

                    {instance?.things === '2' || instance?.things === '3' ?
                        <FormVehicular errors={errors} photos={photos} setPhotos={setPhotos} optional={instance?.injures?.length > 0} maxSize={config?.max_upload_file_size_in_mb} />
                        :
                        <FormThings type={instance?.things} errors={errors} photos={photos} setPhotos={setPhotos} optional={instance?.injures?.length > 0} maxSize={config?.max_upload_file_size_in_mb} />
                    }

                    {Object.keys(errors).length > 0 && (
                        <p className="text-pink text-sm text-center mb-4">(*) Los campos marcados son obligatorios.</p>
                    )}
                    <div className='flex flex-col-reverse md:flex-row w-full justify-between gap-5 mt-10'>
                        <Button handleClick={backStep} type='secondary' className='p-2 md:p-3' title='Volver al paso anterior' />
                        <Button handleClick={nextStep} type='primary' className='p-2 md:p-3' title='Continuar' />
                    </div>

                </div>
            }
            {(subStep === 2) &&
                <div className='flex w-full m-auto flex-col gap-3'>
                    <div className='flex flex-col w-full items-center justify-center md:gap-12'>
                        {(instance?.injures?.length === 0 && instance?.things !== '0') &&
                            (<>
                                <Select
                                    list={options_insured}
                                    selectedValue={lesionados}
                                    onChange={(e) => setLesionados(Number(e.target.value))}
                                    className={`${lesionados === 0 ? 'text-shiny-pink' : 'text-grey-tx'} ${SELECT_CLASSNAME}`}
                                />

                                {lesionados === 0 && (
                                    <p className="text-pink text-sm text-center mb-4">
                                        (*) Los campos marcados son obligatorios.
                                    </p>
                                )}
                            </>
                            )}

                        {instance?.injures?.length > 0 && (
                            <div className='flex flex-col w-full justify-between items-center mt-6 gap-4'>
                                <p className='text-xl text-red font-semibold mb-2 text-center'>Lesionados agregados:</p>
                                <InjuredCard injures={instance?.injures} handleDeleteInjured={handleDeleteInjured} />
                            </div>
                        )}
                        {loading || localLoading ? (
                            <Loader />
                        ) : (
                            (shouldShowInjuresSection) && (
                                <>
                                    {(showInjuresForm) && (
                                        <FormInjures
                                            injures={instance?.injures}
                                            lesionado={lesionado}
                                            handleInjured={handleInjured}
                                            options_bonding={options_bonding}
                                            options_gender={options_gender}
                                            options_injuries={options_injuries}
                                            handleChange={handleChange}
                                            maxSize={config?.max_upload_file_size_in_mb}
                                        />
                                    )}

                                    {(showAddAnotherButton) && (
                                        <div className='flex flex-col w-full justify-between items-center mt-6 gap-4'>
                                            <Button
                                                className='p-2 md:p-3 border-[2px] border-red'
                                                title='¿Desea agregar otro lesionado?'
                                                type='secondary'
                                                handleClick={() => setUploadingLesionado(true)}
                                            />
                                        </div>
                                    )}
                                </>
                            )
                        )}



                    </div>

                    <div className='flex flex-col-reverse md:flex-row w-full justify-between gap-5 mt-10'>
                        <Button handleClick={backSubStep} type='secondary' className='p-2 md:p-3' title='Volver al paso anterior' />
                        <Button handleClick={handleSendClaim} type='primary' className='p-2 md:p-3' title='Continuar' />
                    </div>
                </div>
            }
        </div>
    );
};


Step4.propTypes = {
    avanzar: PropTypes.func,
    retroceder: PropTypes.func,
    formData: PropTypes.object,
    config: PropTypes.object,
    loader: PropTypes.bool,
    setFormData: PropTypes.func
};

export default Step4;